import type { FunctionCallingConfigFormToolField } from "components/formControls/FunctionCallingConfigControl/types";
import type { Tool } from "../types";
import { useHandleGenerateAISchemaSchemaClick } from "ee/PluginActionEditor/hooks/useHandleGenerateAISchemaSchemaClick";
import { transformToolToFunctionCallFormField } from "../utils/transformToolToFunctionCallFormField";

export const useToolEdit = (
  tools: FunctionCallingConfigFormToolField[],
  onChange: (tools: FunctionCallingConfigFormToolField[]) => void,
) => {
  const { handleGenerateAISchemaSchemaClick } =
    useHandleGenerateAISchemaSchemaClick();
  const onToolEdit = (tool: Tool, triggerSave = false) => {
    onChange(
      tools.map((t) =>
        t.entityId === tool.entityId
          ? transformToolToFunctionCallFormField(tool)
          : t,
      ),
    );

    if (triggerSave) {
      setTimeout(() => {
        handleGenerateAISchemaSchemaClick();
      }, 100);
    }
  };

  return { onToolEdit };
};
